import { ResponseNumberSubTypeEnum } from '@ulysses-inc/harami_api_client'

export const SubTypeText = {
  [ResponseNumberSubTypeEnum.BETWEEN]: 'の間',
  [ResponseNumberSubTypeEnum.GREATER_THAN]: '以上',
  [ResponseNumberSubTypeEnum.LESS_THAN]: '以下',
}

/**
 * 数値質問ルールの最小値・最大値に設定できる範囲。
 * 有効なひな形の実用データが全て9桁以内に収まっていることを確認できたため、この範囲としている。
 */
export const NUMBER_RULE_MIN_VALUE = -999_999_999
export const NUMBER_RULE_MAX_VALUE = 999_999_999

/** 数値質問ルールの値が範囲外かどうかを判定する */
export const isNumberRuleOutOfRange = (value: number): boolean =>
  value < NUMBER_RULE_MIN_VALUE || value > NUMBER_RULE_MAX_VALUE

/** 数値質問ルールの範囲外エラーメッセージを生成する */
export const numberRuleOutOfRangeMessage = (
  label: '最小値' | '最大値',
): string =>
  `${label}は${NUMBER_RULE_MIN_VALUE.toLocaleString()}から${NUMBER_RULE_MAX_VALUE.toLocaleString()}の範囲内で入力してください`
